import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import {
  bounceInUpOnEnterAnimation,
  fadeInUpOnEnterAnimation,
} from 'angular-animations';
import confetti from 'canvas-confetti';
import { Observable } from 'rxjs';
import { AuthService } from '../auth/auth.service';
import { LoginRequest } from 'login-data-access';
import { FeedbackUsuarioService } from './../services/feedback-usuario.service';

const RATING_LABELS: Record<number, string> = {
  1: 'Muito insatisfeito',
  2: 'Insatisfeito',
  3: 'Pouco satisfeito',
  4: 'Regular',
  5: 'Neutro',
  6: 'Satisfeito',
  7: 'Bom',
  8: 'Muito bom',
  9: 'Excelente',
  10: 'Excepcional',
};

@Component({
  selector: 'gep-feedback-usuario',
  templateUrl: './feedback-usuario.component.html',
  styleUrls: ['./feedback-usuario.component.css'],
  animations: [
    bounceInUpOnEnterAnimation({ anchor: 'enterAnimation' }),
    fadeInUpOnEnterAnimation({ anchor: 'fade' }),
  ],
  standalone: false,
})
export class FeedbackUsuarioComponent implements OnInit {
  private readonly credentials = this.parseCredentials();

  cpf = '';
  mensagemTexto = '';
  selectedRating = 0;
  lembrarInput = false;
  isSmallScreen$!: Observable<BreakpointState>;

  constructor(
    private feedbackService: FeedbackUsuarioService,
    private authService: AuthService,
    private router: Router,
    public modal: NgbActiveModal,
    private breakpointService: BreakpointObserver,
  ) {
    this.isSmallScreen$ = this.breakpointService.observe('(max-width: 768px)');
  }

  ngOnInit(): void {
    this.cpf = this.credentials.cpf;
    this.loadFeedbackData();
  }

  avaliar(value: number): void {
    if (value === 10) {
      confetti({
        particleCount: 100,
        spread: 70,
        origin: { y: 0.6 },
        zIndex: 9999,
      });
    }
  }

  deslogar(): void {
    this.authService.deslogar();
    this.router.navigateByUrl('/');
  }

  loadFeedbackData(): void {
    if (!this.cpf) {
      return;
    }

    this.feedbackService.getFeedback(this.cpf).subscribe((data) => {
      const feedback = data?.[0];
      if (!feedback) {
        return;
      }

      this.mensagemTexto = this.decodeMensagem(feedback.MENSAGEM);
      this.selectedRating = feedback.NOTA ?? 0;
    });
  }

  submitFeedback(): void {
    this.feedbackService
      .submitFeedback(
        this.cpf,
        this.encodeMensagem(this.mensagemTexto),
        this.selectedRating,
      )
      .subscribe();
  }

  onLembrarChange(value: boolean): void {
    localStorage.removeItem('lembrar');
    localStorage.setItem('lembrar', value.toString());
  }

  get ratingLabel(): string {
    return RATING_LABELS[this.selectedRating] ?? '';
  }

  private parseCredentials(): Pick<LoginRequest, 'cpf'> {
    const raw = sessionStorage.getItem('credentials');
    if (!raw) {
      return { cpf: '' };
    }

    try {
      const parsed = JSON.parse(raw) as LoginRequest;
      return { cpf: parsed.cpf ?? '' };
    } catch {
      return { cpf: '' };
    }
  }

  private encodeMensagem(value: string): string {
    return btoa(unescape(encodeURIComponent(value)));
  }

  private decodeMensagem(value: string): string {
    if (!value) {
      return '';
    }

    try {
      return decodeURIComponent(escape(atob(value)));
    } catch {
      return value;
    }
  }
}
